/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />
/// <reference path="LegacyHelper.js" />
/// <reference path="LegacyEffects.js" />

var GamesMultiplayerConstructionInstance = null;

class GamesMultiplayerConstruction extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		GamesMultiplayerConstructionInstance = this;

		// Multiplayer state is currently not restored for a new connection, so reconnecting is deliberately disabled.
		SignalRConnection.connect("/multiplayerGameHub", false, function(connection) {
			connection.on("React", GamesMultiplayerConstructionInstance.onPing.bind(GamesMultiplayerConstructionInstance));
		});

		if (!this.options.needsConstruction) {
			return;
		}

		if (GenericSoundsInstance == null) {
			GenericSoundsInstance = new GenericSounds(this.options.playFeedbackSound);
		}

		this.constructionElement = document.getElementById(this.options.construction_element);
		this.friendButton = this.constructionElement.querySelector('.friendBtn');
		this.friendsChooser = this.constructionElement.querySelectorAll('[id*="friendsChooserddl"]')[0];
		this.safeObserve(this.friendsChooser, 'change', this.onFriendsChooserChange.bind(this));
		this.json = "";
		this.opponent = "";
		this.accepted = false;

		if (this.options.needsRefreshing) {
			this.safeObserve(document, 'click', this.resetTimer.bind(this));
			this.safeObserve(document, 'mousemove', this.resetTimer.bind(this));
			this.refreshTR = this.options.trRefresh;
			this.timeout = 0;
			this.setTimer();
		}
	}

	setTimer() {
		if (this.json == "") {
			this.timeout = setTimeout(function() {
					var friendSelectionVisible = document.getElementById(this.constructionElement.querySelector('.friendsChooserContainer')).getStyle('display') == 'block';
					if (friendSelectionVisible) {
						confirmAI(this.refreshTR,
							function() {
								location.reload(true);
							},
							function() {},
							true,
							true
						);
					}
					this.resetTimer
				},
				300000);
		}
	}

	resetTimer() {
		window.clearTimeout(this.timeout);
		this.setTimer();
	}

	onFriendsChooserChange(event) {
		if (this.friendsChooser.selectedIndex != 0) {
			this.friendButton.disabled = false;
			this.friendButton.style.opacity = "1";
			this.friendButton.style.cursor = "pointer";
		} else {
			this.friendButton.disabled = true;
			this.friendButton.style.opacity = "0.3";
			this.friendButton.style.cursor = "default";
		}
	}

	onPing(json) {
		if (json.Instance == this.json.instance) {
			if (typeof this.waitScreen == "undefined") {
				this.waitForFriend(true, json);
			}
			this.accepted = true;
			if (json.Status == this.options.status_accepted) {
				this.onSuccess(null);
			} else if (json.Status == this.options.status_declined) {
				GenericSoundsInstance.notificationSound();
				var declineMessage = document.createElement('p').innerHTML = this.opponent + " " + new TextResource(this.options.trDeclined.string());
				declineMessage.style.color = this.options.secondaryColor;
				declineMessage.style.fontWeight = 'bold';
				this.waitScreen.prepend(declineMessage);
			}
			return true;
		}
		return false;
	}

	waitForFriend(goPing, json) {
		this.waitScreen = this.constructionElement.getElementsByClassName("wait_screen")[0];
		//needs to be better implemented + prototype style
		// Remove all controls inside the construction, show the wait screen instead:
		var container = this.constructionElement.querySelectorAll('[id*="multiplayer_mainDiv"]')[0];
		while (container.lastChild) {
			var elem = container.lastChild;
			this.stopObserveAllListeners(elem);
			container.removeChild(elem);
		}
		container.prepend(this.waitScreen);
		this.waitScreen.style.display = "block";

		this.waitDragon = this.constructionElement.getElementsByClassName("waiting_dragon").item(0);
		this.waitDragonMirror = this.constructionElement.getElementsByClassName("waiting_dragon_mirrored").item(0);
		this.dragonFly(true);

		if (goPing) {
			this.onPing(json);
		}
	}

	dragonFly(isLeft) {
		if (isLeft) {
			this.waitDragon.style.visibility = "visible";
			this.waitDragonMirror.style.visibility = "hidden";
			LegacyEffects.move(this.waitDragon, { x: 290, y: 0, mode: 'relative', duration: 10.0 });
			LegacyEffects.move(this.waitDragonMirror, { x: 290, y: 0, mode: 'relative', duration: 10.0 });
		} else {
			this.waitDragon.style.visibility = "hidden";
			this.waitDragonMirror.style.visibility = "visible";
			LegacyEffects.move(this.waitDragon, { x: -290, y: 0, mode: 'relative', duration: 10.0 });
			LegacyEffects.move(this.waitDragonMirror, { x: -290, y: 0, mode: 'relative', duration: 10.0 });
		}
		window.setTimeout(() => { this.dragonFly(!isLeft) }, 10000);
	}

	onSuccess(req) {
		if (!this.accepted && req.data.not_allowed) {
			confirmAI(this.options.trForbidden, function() {}, function() {}, true, false);
			return;
		}

		if (!(this.level == 0 && this.accepted)) {
			this.json = req.data;
		}
		if (this.level == 0 && !this.accepted) {
			this.waitForFriend(false, null);
			return true;
		}

		// remove all children
		while (this.constructionElement.lastChild) {
			var elem = this.constructionElement.lastChild;
			this.stopObserveAllListeners(elem);
			this.constructionElement.removeChild(elem);
		}

		// add game
		this.constructionElement.innerHTML = this.json.multiplayerGame;
		evalScripts(this.constructionElement);
	}

	onError(req) {
		//it's okay to be in here. This probably just says you got into waitForFriend before finishing onSuccess
	}

	onFailure(req) {
		console.log("GamesMultiplayerConstruction.onFailure", req);
	}
}
